import React from "react";
import SiteLayout from "@/components/SiteLayout";
import TestimonialCarousel from "@/components/TestimonialCarousel";
import useScrollReveal from "@/hooks/useScrollReveal";
import HeroBadge from "@/components/HeroBadge";
import { Quote, Star, Sparkles } from "lucide-react";

const T = [
  { n: "Jignesh Patel", p: "Family Premium", c: "Adajan East", q: "My father's cardiac emergency was handled in under 20 minutes. The Nirmal Adajan team had a senior cardiologist ready before we reached.", color: "1E4F87" },
  { n: "Priya Desai", p: "Family Premium", c: "Pal", q: "Annual check-ups for my parents and kids — coordinated on a single WhatsApp thread. Truly care par excellence.", color: "A53A2A" },
  { n: "Rohit Mehta", p: "Family Premium", c: "Honey Park", q: "The second-opinion benefit gave us peace of mind during a difficult diagnosis. Worth every rupee.", color: "0F2540" },
  { n: "Sneha Shah", p: "Individual", c: "Palanpur Patia", q: "The diagnostics discounts pay for the membership twice over. The digital card is genuinely premium.", color: "1F7A3D" },
  { n: "Vikram Trivedi", p: "Family Premium", c: "Adajan West", q: "Priority appointments at the new building OPD have saved us countless hours. Highly recommended for our area.", color: "C89B3C" },
  { n: "Ananya Joshi", p: "Family Premium", c: "Rander", q: "Everything about the Adajan Nirmal Privilege Card feels deliberate — the card, the dashboard, the human support.", color: "7A2A1E" },
];
const av = (t) => `https://ui-avatars.com/api/?name=${encodeURIComponent(t.n)}&background=${t.color}&color=FFFFFF&bold=true&size=200&font-size=0.40`;

export default function Testimonials() {
  useScrollReveal();
  return (
    <SiteLayout>
      <section className="hero-grad relative overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-50 pointer-events-none" />
        <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-10 relative">
          <div className="max-w-3xl reveal">
            <HeroBadge>Testimonials · <span className="text-[#A53A2A]">4.9 / 5 · 2,400+ Reviews</span></HeroBadge>
            <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-bold text-[#0F2540] leading-[1.04]">
              Stories from <span className="bg-gradient-to-r from-[#A53A2A] via-[#C89B3C] to-[#A53A2A] bg-clip-text text-transparent">our neighbours.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-lg text-[#5C6B7A]">Real voices from families across Adajan, Pal, Rander, Honey Park and Palanpur Patia who trust Nirmal Hospital New Building for everyday care and emergencies.</p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 py-12">
        <TestimonialCarousel />
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 py-12">
        <div className="reveal max-w-2xl">
          <span className="overline">All reviews</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-[#0F2540]">More from Adajan members.</h2>
        </div>
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {T.map((x, i) => (
            <figure key={i} className="reveal lux-card rounded-2xl p-7" style={{ animationDelay: `${i * 80}ms` }}>
              <div className="flex items-center justify-between">
                <div className="flex">{Array.from({ length: 5 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-[#C89B3C] text-[#C89B3C]" />)}</div>
                <Quote className="h-5 w-5 text-[#A53A2A]" />
              </div>
              <blockquote className="mt-4 text-[#0F2540] leading-relaxed">"{x.q}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img src={av(x)} alt={x.n} className="h-11 w-11 rounded-full ring-2 ring-white shadow" />
                <div>
                  <div className="text-sm font-semibold text-[#0F2540]">{x.n}</div>
                  <div className="text-[11px] uppercase tracking-wider text-[#5C6B7A]">{x.p} · {x.c}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}
